module.exports = __webpack_public_path__ + "img/arrow-sections.a1a25082.svg";